import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusMovieSidebar from 'components/editor/movies/movieSidebar/movieSidebarFocus';
import UniversalMovieSidebar from 'components/editor/movies/movieSidebar/movieSidebarUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieSidebar {...props} />;
	return <UniversalMovieSidebar {...props} />;
};